export enum FormFieldTypes {
  section = 'section',
  text = 'text',
  number = 'number',
  textarea = 'textarea',
  select = 'select',
  checkbox = 'checkbox',
  radio = 'radio',
  date = 'date',
}
